export default __webpack_public_path__ + "static/media/ClientesIconEdit.17020eb7.svg";